webpackJsonp([137408898365125],{

/***/ "./assets/email-icon.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./assets/linkedin-icon.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "./src/components/HeroQuote.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  text-align: center;\n  background-color: ", ";\n  color: ", ";\n  align-conent: center;\n  margin: auto;\n  padding: ", ";\n"], ["\n  display: grid;\n  text-align: center;\n  background-color: ", ";\n  color: ", ";\n  align-conent: center;\n  margin: auto;\n  padding: ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  line-height: 1.5;\n  padding: 1rem;\n  text-align: center;\n  ", ";\n  font-size: 2.5rem;\n  font-weight: 400;\n  strong {\n    font-weight: 500;\n  }\n\n  ", ";\n"], ["\n  display: inline-block;\n  line-height: 1.5;\n  padding: 1rem;\n  text-align: center;\n  ", ";\n  font-size: 2.5rem;\n  font-weight: 400;\n  strong {\n    font-weight: 500;\n  }\n\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    font-size: 1.65rem;\n  "], ["\n    font-size: 1.65rem;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  line-height: 1.5;\n  font-size: 1rem;\n  text-align: center;\n"], ["\n  line-height: 1.5;\n  font-size: 1rem;\n  text-align: center;\n"]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _FadeIn = __webpack_require__("./src/components/atoms/FadeIn.js");
	
	var _FadeIn2 = _interopRequireDefault(_FadeIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = _styledComponents2.default.div(_templateObject, function (_ref) {
	  var theme = _ref.theme,
	      color = _ref.color;
	  return theme.colors[color];
	}, function (_ref2) {
	  var theme = _ref2.theme,
	      fontColor = _ref2.fontColor;
	  return theme.colors[fontColor];
	}, function (_ref3) {
	  var padding = _ref3.padding;
	  return padding ? padding : "8rem 6.25rem 12rem 6.25rem";
	});
	
	var Quote = _typography.H3.extend(_templateObject2, _utils.getFontFamily, function (props) {
	  return props.theme.media.tablet(_templateObject3);
	});
	
	var Author = _typography.P.extend(_templateObject4);
	
	exports.default = function (_ref4) {
	  var _ref4$color = _ref4.color,
	      color = _ref4$color === undefined ? "transparent" : _ref4$color,
	      _ref4$quote = _ref4.quote,
	      quote = _ref4$quote === undefined ? "" : _ref4$quote,
	      _ref4$author = _ref4.author,
	      author = _ref4$author === undefined ? "" : _ref4$author,
	      _ref4$fontColor = _ref4.fontColor,
	      fontColor = _ref4$fontColor === undefined ? "dark" : _ref4$fontColor,
	      _ref4$padding = _ref4.padding,
	      padding = _ref4$padding === undefined ? null : _ref4$padding,
	      _ref4$zIndex = _ref4.zIndex,
	      zIndex = _ref4$zIndex === undefined ? null : _ref4$zIndex,
	      _ref4$style = _ref4.style,
	      style = _ref4$style === undefined ? {} : _ref4$style,
	      props = _objectWithoutProperties(_ref4, ["color", "quote", "author", "fontColor", "padding", "zIndex", "style"]);
	
	  return _react2.default.createElement(
	    Section,
	    {
	      color: color,
	      fontColor: fontColor,
	      padding: padding,
	      style: _extends({}, style, { zIndex: zIndex })
	    },
	    _react2.default.createElement(
	      _FadeIn2.default,
	      null,
	      _react2.default.createElement(
	        Quote,
	        props,
	        _react2.default.createElement(_reactMarkdown2.default, { source: quote })
	      ),
	      _react2.default.createElement(
	        Author,
	        { align: "center" },
	        author
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PictureCard.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 20rem;\n  ", ";\n"], ["\n  display: flex;\n  height: 20rem;\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    flex-wrap: wrap;\n    height: auto;\n  "], ["\n    flex-wrap: wrap;\n    height: auto;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  background-color: ", ";\n  padding: 3rem;\n  ", ";\n"], ["\n  color: ", ";\n  background-color: ", ";\n  padding: 3rem;\n  ", ";\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    padding: 2rem;\n  "], ["\n    padding: 2rem;\n  "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  font-size: 1.35rem;\n  ", ";\n  a,\n  a:visited {\n    color: white;\n  }\n"], ["\n  font-size: 1.35rem;\n  ", ";\n  a,\n  a:visited {\n    color: white;\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    font-size: 1.1rem;\n  "], ["\n    font-size: 1.1rem;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMarkdown = __webpack_require__("./node_modules/react-markdown/src/react-markdown.js");
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Background = __webpack_require__("./src/components/blocks/Background.js");
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _AspectImage = __webpack_require__("./src/components/atoms/AspectImage.js");
	
	var _AspectImage2 = _interopRequireDefault(_AspectImage);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _Background2.default.extend(_templateObject, function (props) {
	  return props.theme.media.mobile(_templateObject2);
	});
	
	var Body = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.colors.white;
	}, (0, _utils.getThemeColor)("teal"), function (props) {
	  return props.theme.media.tablet(_templateObject4);
	});
	
	var BodyText = _typography.P.extend(_templateObject5, function (props) {
	  return props.theme.media.card(_templateObject6);
	});
	
	exports.default = function (_ref) {
	  var _ref$picture = _ref.picture,
	      picture = _ref$picture === undefined ? "" : _ref$picture,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? "" : _ref$title,
	      _ref$subtitle = _ref.subtitle,
	      subtitle = _ref$subtitle === undefined ? "" : _ref$subtitle,
	      _ref$text = _ref.text,
	      text = _ref$text === undefined ? "" : _ref$text,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? "teal" : _ref$color,
	      _ref$pictureAlign = _ref.pictureAlign,
	      pictureAlign = _ref$pictureAlign === undefined ? "left" : _ref$pictureAlign;
	  return _react2.default.createElement(
	    _Section2.default,
	    { color: "halfGrey", fixed: true },
	    _react2.default.createElement(
	      Container,
	      { color: "halfGrey", style: { display: "flex" } },
	      pictureAlign === "left" && _react2.default.createElement(
	        _Responsive.HideMobile,
	        { style: { flex: 1 } },
	        _react2.default.createElement(_AspectImage2.default, { direction: "vertical", aspect: 1, src: picture, inline: true })
	      ),
	      _react2.default.createElement(
	        _Responsive.ShowMobile,
	        null,
	        _react2.default.createElement(_AspectImage2.default, { direction: "horizontal", aspect: 1, src: picture, inline: true })
	      ),
	      _react2.default.createElement(
	        Body,
	        { color: color, style: { flex: 2 } },
	        _react2.default.createElement(
	          _typography.P,
	          { serif: true, color: "white" },
	          title
	        ),
	        _react2.default.createElement(
	          _typography.Description,
	          { color: "white" },
	          subtitle
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 0.5 }),
	        _react2.default.createElement(
	          BodyText,
	          { color: "white" },
	          _react2.default.createElement(_reactMarkdown2.default, { source: text })
	        )
	      ),
	      pictureAlign === "right" && _react2.default.createElement(
	        _Responsive.HideMobile,
	        { style: { flex: 1 } },
	        _react2.default.createElement(_AspectImage2.default, { direction: "vertical", aspect: 1, src: picture, inline: true })
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/components/PictureGrid.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding-top: 1rem;\n  padding-bottom: .5rem;\n"], ["\n  padding-top: 1rem;\n  padding-bottom: .5rem;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: .5rem 1rem;\n  color: white;\n  font-size: .8rem;\n  line-height: 1.4;\n  text-align: center;\n  transition: opacity 500ms;\n  cursor: pointer;\n\n  &:hover,\n  &:active {\n    opacity: .55;\n    background-color: ", ";\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: .5rem 1rem;\n  color: white;\n  font-size: .8rem;\n  line-height: 1.4;\n  text-align: center;\n  transition: opacity 500ms;\n  cursor: pointer;\n\n  &:hover,\n  &:active {\n    opacity: .55;\n    background-color: ", ";\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n"], ["\n  width: 100%;\n  display: flex;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["position: relative;"], ["position: relative;"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 3rem 0.5rem;\n  padding: ", ";\n  ", ";\n\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 3rem 0.5rem;\n  padding: ", ";\n  ", ";\n\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(2, 1fr);\n  "], ["\n    grid-template-columns: repeat(2, 1fr);\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(1, 1fr);\n    padding: 0;\n  "], ["\n    grid-template-columns: repeat(1, 1fr);\n    padding: 0;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _Responsive = __webpack_require__("./src/components/blocks/Responsive.js");
	
	var _Image = __webpack_require__("./src/components/Image.js");
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _linkedinIcon = __webpack_require__("./assets/linkedin-icon.png");
	
	var _linkedinIcon2 = _interopRequireDefault(_linkedinIcon);
	
	var _emailIcon = __webpack_require__("./assets/email-icon.png");
	
	var _emailIcon2 = _interopRequireDefault(_emailIcon);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Profile = _styledComponents2.default.div(_templateObject);
	
	var Name = _typography.H5.extend(_templateObject2);
	
	var Bio = _styledComponents2.default.div(_templateObject3, (0, _utils.getThemeColor)("purpleDark"));
	
	var ImageFull = _styledComponents2.default.img(_templateObject4);
	
	var Overlay = _styledComponents2.default.div(_templateObject5);
	
	var Picture = function Picture(_ref) {
	  var _ref$person = _ref.person,
	      person = _ref$person === undefined ? {} : _ref$person,
	      select = _ref.select;
	  return _react2.default.createElement(
	    Profile,
	    { onClick: function onClick() {
	        return select(person);
	      } },
	    person.src && _react2.default.createElement(
	      Overlay,
	      null,
	      _react2.default.createElement(ImageFull, { src: person.src, align: "flex-start", full: true }),
	      _react2.default.createElement(
	        Bio,
	        null,
	        "View ",
	        person.name.split(" ")[0],
	        "'s bio"
	      )
	    ),
	    _react2.default.createElement(
	      Name,
	      { serif: true },
	      person.name
	    ),
	    _react2.default.createElement(
	      _typography.Description,
	      null,
	      person.description
	    )
	  );
	};
	
	var Grid = _styledComponents2.default.div(_templateObject6, function (_ref2) {
	  var padLarge = _ref2.padLarge;
	  return padLarge ? "4rem 2rem" : "0rem 2rem";
	}, function (props) {
	  return props.theme.media.tablet(_templateObject7);
	}, function (props) {
	  return props.theme.media.mobile(_templateObject8);
	});
	
	exports.default = function (_ref3) {
	  var _ref3$persons = _ref3.persons,
	      persons = _ref3$persons === undefined ? [] : _ref3$persons,
	      _ref3$title = _ref3.title,
	      title = _ref3$title === undefined ? "" : _ref3$title,
	      _ref3$padLarge = _ref3.padLarge,
	      padLarge = _ref3$padLarge === undefined ? false : _ref3$padLarge,
	      selectPerson = _ref3.selectPerson;
	  return _react2.default.createElement(
	    Grid,
	    { padLarge: padLarge },
	    persons.map(function (person) {
	      return _react2.default.createElement(Picture, { person: person, select: selectPerson });
	    })
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/vercel/path0/node_modules/babel-preset-react-app/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\",[\"/vercel/path0/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"IE >= 9\",\"Safari >= 9\",\"last 2 versions\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/vercel/path0/node_modules/babel-preset-stage-0/lib/index.js\",\"/vercel/path0/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/vercel/path0/node_modules/react-hot-loader/babel.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/vercel/path0/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/team.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  height: 2rem;\n  padding-right: 1rem;\n  padding-top: 1rem;\n"], ["\n  height: 2rem;\n  padding-right: 1rem;\n  padding-top: 1rem;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  text-style: italic;\n  font-size: 1.3rem;\n  @media (max-width: 1100px) {\n    display: none;\n  }\n"], ["\n  text-style: italic;\n  font-size: 1.3rem;\n  @media (max-width: 1100px) {\n    display: none;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  left: 0;\n  top: 2rem;\n  padding-bottom: 4rem;\n  right: 0;\n  overflow: hidden;\n  padding: 2rem 3rem;\n  z-index: 3;\n  font-size: 1rem;\n  opacity: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  transition: opacity 300ms;\n  pointer-events: ", ";\n  opacity: ", ";\n\n  @media (max-width: 700px) {\n    bottom: 2rem;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n"], ["\n  position: fixed;\n  left: 0;\n  top: 2rem;\n  padding-bottom: 4rem;\n  right: 0;\n  overflow: hidden;\n  padding: 2rem 3rem;\n  z-index: 3;\n  font-size: 1rem;\n  opacity: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  transition: opacity 300ms;\n  pointer-events: ", ";\n  opacity: ", ";\n\n  @media (max-width: 700px) {\n    bottom: 2rem;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  padding: 2rem 3rem;\n  max-width: 720px;\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n"], ["\n  padding: 2rem 3rem;\n  max-width: 720px;\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["font-size: 1.3rem;"], ["font-size: 1.3rem;"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  margin-top: -5rem;\n\n  ", ";\n"], ["\n  margin-top: -5rem;\n\n  ", ";\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    margin-top: 0;\n  "], ["\n    margin-top: 0;\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  flex-wrap: wrap;\n  width: 100%;\n  margin: 2rem auto 0 -2rem;\n  padding: 0;\n  ", ";\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  flex-wrap: wrap;\n  width: 100%;\n  margin: 2rem auto 0 -2rem;\n  padding: 0;\n  ", ";\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n    justify-content: flex-start;\n    gap: 2rem;\n    margin: 2rem auto 0;\n    padding: 0 1.5rem;\n    max-width: 100%;\n    overflow: hidden;\n  "], ["\n    justify-content: flex-start;\n    gap: 2rem;\n    margin: 2rem auto 0;\n    padding: 0 1.5rem;\n    max-width: 100%;\n    overflow: hidden;\n  "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  max-height: ", ";\n  max-width: 156px;\n  object-fit: contain;\n  filter: grayscale(100%);\n  opacity: 1;\n  ", ";\n"], ["\n  max-height: ", ";\n  max-width: 156px;\n  object-fit: contain;\n  filter: grayscale(100%);\n  opacity: 1;\n  ", ";\n"]),
	    _templateObject11 = _taggedTemplateLiteralLoose(["\n    max-height: ", ";\n    max-width: 125px;\n  "], ["\n    max-height: ", ";\n    max-width: 125px;\n  "]);
	
	var _react = __webpack_require__("./node_modules/gatsby-plugin-react-next/node_modules/react/index.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recompose = __webpack_require__("./node_modules/recompose/cjs/Recompose.js");
	
	var _utils = __webpack_require__("./src/utils.js");
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _selectors = __webpack_require__("./src/selectors.js");
	
	var _PictureCard = __webpack_require__("./src/components/PictureCard.js");
	
	var _PictureCard2 = _interopRequireDefault(_PictureCard);
	
	var _Flex = __webpack_require__("./src/components/blocks/Flex.js");
	
	var _Flex2 = _interopRequireDefault(_Flex);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__("./src/components/typography/index.js");
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _ContentSection = __webpack_require__("./src/components/blocks/ContentSection.js");
	
	var _ContentSection2 = _interopRequireDefault(_ContentSection);
	
	var _HeroQuote = __webpack_require__("./src/components/HeroQuote.js");
	
	var _HeroQuote2 = _interopRequireDefault(_HeroQuote);
	
	var _PictureGrid = __webpack_require__("./src/components/PictureGrid.js");
	
	var _PictureGrid2 = _interopRequireDefault(_PictureGrid);
	
	var _kevin = __webpack_require__("./assets/kevin.jpg");
	
	var _kevin2 = _interopRequireDefault(_kevin);
	
	var _Emphasis = __webpack_require__("./src/components/atoms/Emphasis.js");
	
	var _Emphasis2 = _interopRequireDefault(_Emphasis);
	
	var _Section = __webpack_require__("./src/components/blocks/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Pad = __webpack_require__("./src/components/blocks/Pad.js");
	
	var _Pad2 = _interopRequireDefault(_Pad);
	
	var _Spacer = __webpack_require__("./src/components/blocks/Spacer.js");
	
	var _Spacer2 = _interopRequireDefault(_Spacer);
	
	var _logofavcon2x = __webpack_require__("./assets/logofavcon@2x.png");
	
	var _logofavcon2x2 = _interopRequireDefault(_logofavcon2x);
	
	var _linkedinIcon = __webpack_require__("./assets/linkedin-icon.png");
	
	var _linkedinIcon2 = _interopRequireDefault(_linkedinIcon);
	
	var _emailIcon = __webpack_require__("./assets/email-icon.png");
	
	var _emailIcon2 = _interopRequireDefault(_emailIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Icon = _styledComponents2.default.img(_templateObject);
	
	var Memoriam = _styledComponents2.default.div(_templateObject2);
	
	var BioOverlay = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.visible ? "inherit" : "none";
	}, function (props) {
	  return props.visible ? 1 : 0;
	});
	
	var BioOverlayBody = _styledComponents2.default.div(_templateObject4, (0, _utils.getThemeColor)("purpleDark"));
	
	var BioText = _typography.P.extend(_templateObject5);
	
	var JoinUsWrapper = _styledComponents2.default.div(_templateObject6, function (props) {
	  return props.theme.media.mobile(_templateObject7);
	});
	
	var InvestorLogos = _styledComponents2.default.div(_templateObject8, function (props) {
	  return props.theme.media.mobile(_templateObject9);
	});
	
	var InvestorLogo = _styledComponents2.default.img(_templateObject10, function (props) {
	  return props.square ? '64px' : '42px';
	}, function (props) {
	  return props.theme.media.mobile(_templateObject11, function (props) {
	    return props.square ? '51px' : '34px';
	  });
	});
	
	var getInitials = function getInitials(name) {
	  return name.split(" ").map(function (n) {
	    return n[0];
	  }).join("").toUpperCase().slice(0, 2);
	};
	
	var makePlaceholder = function makePlaceholder(name) {
	  var initials = getInitials(name);
	  return "data:image/svg+xml," + encodeURIComponent("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"400\" height=\"300\" viewBox=\"0 0 400 300\"><rect fill=\"#b0b8c4\" width=\"400\" height=\"300\"/><text fill=\"#fff\" font-family=\"Arial,sans-serif\" font-size=\"120\" x=\"200\" y=\"160\" text-anchor=\"middle\" dominant-baseline=\"middle\">" + initials + "</text></svg>");
	};
	
	var getShortBio = function getShortBio(bio) {
	  var sentences = bio.split(/(?<=[.!?])\s+/);
	  return sentences[0].trim().endsWith("Dr.") ? sentences.slice(0, 2).join(" ") : sentences[0];
	};
	
	var enhance = (0, _recompose.withState)("selectedPerson", "selectPerson", null);
	
	var TeamPage = function (_React$Component) {
	  _inherits(TeamPage, _React$Component);
	
	  function TeamPage() {
	    _classCallCheck(this, TeamPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TeamPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var content = (0, _selectors.getGraphNode)(this.props.data, "TeamPage");
	
	    var team = content.teamMembers.map(function (person) {
	      return _extends({}, person, {
	        bio: person.bio.bio,
	        description: person.position,
	        src: person.image ? person.image.responsiveResolution.src : _kevin2.default
	      });
	    }),
	        board = content.boardMembers.map(function (person) {
	      return _extends({}, person, {
	        bio: person.bio.bio,
	        description: person.shortBio || getShortBio(person.bio.bio),
	        src: person.image ? person.image.responsiveResolution.src : makePlaceholder(person.name)
	      });
	    }),
	        advisors = content.advisoryBoard.map(function (person) {
	      return _extends({}, person, {
	        bio: person.bio.bio,
	        description: person.shortBio || getShortBio(person.bio.bio),
	        src: person.image ? person.image.responsiveResolution.src : makePlaceholder(person.name)
	      });
	    });
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: "Contraline Team",
	          meta: [{ name: "Contraline", content: "Team" }]
	        },
	        _react2.default.createElement("link", { rel: "icon", type: "image/png", href: _logofavcon2x2.default })
	      ),
	      _react2.default.createElement(_NavBar2.default, { color: "dark" }),
	      _react2.default.createElement(_HeroQuote2.default, {
	        padding: "1rem",
	        serif: true,
	        color: "white",
	        quote: content.heroQuote,
	        author: content.heroAuthor,
	        style: {
	          minHeight: "20rem",
	          display: "flex",
	          flexDirection: "column",
	          justifyContent: "center"
	        }
	      }),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "white" },
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 2 },
	          _react2.default.createElement(
	            _Emphasis2.default,
	            null,
	            _react2.default.createElement(
	              _typography.H4,
	              null,
	              content.ourTeamHeader
	            )
	          )
	        ),
	        _react2.default.createElement(_PictureGrid2.default, { persons: team, selectPerson: this.props.selectPerson })
	      ),
	      _react2.default.createElement(
	        BioOverlay,
	        {
	          visible: !!this.props.selectedPerson,
	          onClick: function onClick(e) {
	            console.log(e.target);
	            if (e.target.className.indexOf("overlay") > -1) _this2.props.selectPerson(null);
	          },
	          className: "overlay"
	        },
	        this.props.selectedPerson && _react2.default.createElement(
	          BioOverlayBody,
	          null,
	          _react2.default.createElement(
	            _Flex2.default,
	            null,
	            _react2.default.createElement(
	              _typography.H3,
	              { color: "white", style: { flex: 1 } },
	              this.props.selectedPerson.name
	            ),
	            _react2.default.createElement(
	              _typography.H3,
	              {
	                color: "white",
	                onClick: function onClick() {
	                  return _this2.props.selectPerson(null);
	                },
	                style: { cursor: "pointer" }
	              },
	              "X"
	            )
	          ),
	          this.props.selectedPerson.position && _react2.default.createElement(
	            _typography.H4,
	            { color: "white" },
	            this.props.selectedPerson.position
	          ),
	          _react2.default.createElement(_Spacer2.default, { span: 0.4 }),
	          _react2.default.createElement(
	            BioText,
	            { color: "white" },
	            this.props.selectedPerson.bio
	          ),
	          _react2.default.createElement(
	            _Flex2.default,
	            { justify: "flex-start" },
	            this.props.selectedPerson.linkedin && _react2.default.createElement(
	              "a",
	              { href: this.props.selectedPerson.linkedin },
	              _react2.default.createElement(Icon, { src: _linkedinIcon2.default })
	            ),
	            this.props.selectedPerson.email && _react2.default.createElement(
	              "a",
	              { href: "mailto:" + this.props.selectedPerson.email },
	              _react2.default.createElement(Icon, { src: _emailIcon2.default })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        JoinUsWrapper,
	        null,
	        _react2.default.createElement(_ContentSection2.default, {
	          color: "white",
	          titleText: content.sectionTitle,
	          bodyText: content.sectionBody.sectionBody.split("|"),
	          link: {
	            label: content.sectionLink,
	            to: "/careers"
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _Section2.default,
	        { color: "greyLight" },
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 3 },
	          _react2.default.createElement(
	            _Emphasis2.default,
	            null,
	            _react2.default.createElement(
	              _typography.H4,
	              null,
	              content.investorsTitle || "Our Investors"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          InvestorLogos,
	          null,
	          content.investors && content.investors.length > 0 ? content.investors.map(function (inv, i) {
	            return _react2.default.createElement(InvestorLogo, {
	              key: i,
	              src: inv.logo ? inv.logo.responsiveResolution.src : "",
	              alt: inv.name,
	              onLoad: function onLoad(e) {
	                var img = e.target;
	                if (img.naturalWidth / img.naturalHeight < 1.5) {
	                  img.style.maxHeight = '64px';
	                }
	              }
	            });
	          }) : [1, 2, 3, 4, 5].map(function (i) {
	            return _react2.default.createElement(InvestorLogo, {
	              key: i,
	              src: "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png",
	              alt: "Investor logo placeholder"
	            });
	          })
	        ),
	        _react2.default.createElement(_Spacer2.default, { span: 4 }),
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 3 },
	          _react2.default.createElement(
	            _Emphasis2.default,
	            null,
	            _react2.default.createElement(
	              _typography.H4,
	              null,
	              content.directorsTitle
	            )
	          )
	        ),
	        _react2.default.createElement(_PictureGrid2.default, { persons: board, selectPerson: this.props.selectPerson }),
	        _react2.default.createElement(
	          _Pad2.default,
	          { v: 4 },
	          _react2.default.createElement(
	            _Pad2.default,
	            { v: 3 },
	            _react2.default.createElement(
	              _Emphasis2.default,
	              null,
	              _react2.default.createElement(
	                _typography.H4,
	                null,
	                content.advisoryBoardTitle
	              )
	            )
	          ),
	          _react2.default.createElement(_PictureGrid2.default, { padLarge: false, persons: advisors, selectPerson: this.props.selectPerson })
	        )
	      ),
	      _react2.default.createElement(_PictureCard2.default, {
	        picture: content.johnHerrImage.responsiveResolution.src,
	        color: "herrBlue",
	        title: _react2.default.createElement(
	          _Flex2.default,
	          null,
	          _react2.default.createElement(
	            "span",
	            null,
	            content.johnHerrTitle
	          ),
	          _react2.default.createElement(
	            Memoriam,
	            null,
	            content.inMemoriam
	          )
	        ),
	        subtitle: content.johnHerrSubtitle,
	        text: content.johnHerrBody.johnHerrBody
	      })
	    );
	  };
	
	  return TeamPage;
	}(_react2.default.Component);
	
	exports.default = enhance(TeamPage);
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-team-js-05f4f15a6daaf0f8bbc8.js